package com.dotdrives.web.pages.forms

import react.FC
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.label
import react.dom.html.ReactHTML.option
import react.dom.html.ReactHTML.select
import react.dom.html.ReactHTML.span
import react.dom.html.ReactHTML.textarea
import web.cssom.ClassName
import web.html.InputType
import web.html.color
import web.html.text

/** Story and brand use the same persisted configuration as the donor page. */
val PublicFormConfiguration = FC<FormTabProps> { props ->
    val state = props.state
    val controller = props.controller
    label {
        className = ClassName("forms-v2-field")
        span { +"Public headline" }
        input {
            type = InputType.text; value = state.draftHeadline; ariaLabel = "Public headline"
            placeholder = "e.g. Keep kids in school through sport"; disabled = !props.canWrite
            onChange = { if (props.canWrite) controller.setHeadline(it.currentTarget.value) }
        }
    }
    label {
        className = ClassName("forms-v2-field")
        span {
            className = ClassName("forms-v2-field-heading")
            +"Campaign story"
            span { className = ClassName("forms-v2-counter" + if (state.draftStory.length > 5000) " forms-v2-invalid" else ""); +"${state.draftStory.length} / 5000" }
        }
        textarea {
            value = state.draftStory; rows = 9; ariaLabel = "Campaign story"; disabled = !props.canWrite
            onChange = { if (props.canWrite) controller.setStory(it.currentTarget.value) }
        }
        span { className = ClassName("forms-v2-help"); +"Put your ask first. Donors can expand the full story on phones." }
    }
    div {
        className = ClassName("forms-v2-two-columns")
        div {
            className = ClassName("forms-v2-field")
            span { +"Accent color" }
            span { className = ClassName("forms-v2-help"); +"Header stripe and giving controls" }
            div {
                className = ClassName("forms-v2-color")
                input {
                    type = InputType.color; ariaLabel = "Choose accent color"; disabled = !props.canWrite
                    value = state.draftDesign.backgroundColor?.takeIf { Regex("#[0-9a-fA-F]{6}").matches(it) } ?: "#F26223"
                    onChange = { if (props.canWrite) controller.setDesign(state.draftDesign.copy(backgroundColor = it.currentTarget.value)) }
                }
                input {
                    type = InputType.text; ariaLabel = "Accent color"; disabled = !props.canWrite
                    value = state.draftDesign.backgroundColor.orEmpty(); placeholder = "#F26223"
                    onChange = { if (props.canWrite) controller.setDesign(state.draftDesign.copy(backgroundColor = it.currentTarget.value.takeIf(String::isNotBlank))) }
                }
            }
        }
        label {
            className = ClassName("forms-v2-field")
            span { +"Story font" }; span { className = ClassName("forms-v2-help"); +"Story paragraph only" }
            select {
                value = state.draftDesign.font ?: "Nunito Sans"; ariaLabel = "Story font"; disabled = !props.canWrite
                onChange = { if (props.canWrite) controller.setDesign(state.draftDesign.copy(font = it.currentTarget.value)) }
                listOf("Nunito Sans", "Quicksand", "IBM Plex Mono").forEach { font -> option { value = font; +font } }
            }
        }
    }
    FormLogoUpload { this.state = state; this.controller = controller; canWrite = props.canWrite }
}
